import {COLLECTION_USER} from '../users/constants';
import {SUBCOLLECTION_TODO} from './constants';

export function getTodoCollectionPath(uid: string): string {
  return `${COLLECTION_USER}/${uid}/${SUBCOLLECTION_TODO}`;
}
